

import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Avatars from './Avatars'
import useTranslations from "../transalation/TranslationUtils";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { initSimpleData, setSimpleData, setSimpleDataToMemberData } from "app/redux/slices/rdxMemberSlice";
import { FormControlLabel, Switch } from "@mui/material";
import axios from "axios";
import { DEFAULT_IP } from "app/utils/constant";
function Caregiver() {
    const { appointedCaregiverSetting, savechaneg, cancel,
        showErrMsg, showSuccessMsg,
        handcraft, visit } = useTranslations()

    const dispatch = useDispatch();

    const memberEditData = useSelector((state) => state.rdxMember?.memberEditData || {});
    const editCaregiver = useSelector((state) => state.rdxMember?.editCaregiver || {});

    const [isSuccess, setIsSuccess] = useState(false);
    const [resultMsg, setResultMsg] = useState("");

    useEffect(() => {
        let data = {
            data: memberEditData,
            projection: "editCaregiver",
            type: "obj"
        };
        dispatch(initSimpleData(data));
    }, []);

    const handleSwitchChange = (e) => {
        let data = {
            data: !editCaregiver.is_appointed_caregiver,
            projection: "editCaregiver",
            path: "is_appointed_caregiver"
        }
        dispatch(setSimpleData(data));
    }

    const onUpdateCaregiverClick = async () => {
        const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/updatememberappointedcaregiver", {
            is_appointed_caregiver: editCaregiver.is_appointed_caregiver,
            account_id: memberEditData.account_id
        });
        let data = postRes.data;

        if (1 == data?.code) {
            let rData = {
                data: editCaregiver,
                projection: "self",
                base: memberEditData
            };
            dispatch(setSimpleDataToMemberData(rData));
            setIsSuccess(true);
            setResultMsg("Appointed Caregiver Setting update successful!");
        } else {
            setIsSuccess(false);
            setResultMsg(showErrMsg(data));
        }
    }


    return (
        <Container fluid>
            <Row>
                <Col md={12}>
                    <Card className="mt-0 border-0" style={{ position: "relative" }}>
                        <Card.Body>
                            <Avatars initAvatar={memberEditData["account_avatar"]} />
                            <br />
                            <Card className="m-3 p-3">
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <h5 className="basicinfo">
                                                {appointedCaregiverSetting()}
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={editCaregiver.is_appointed_caregiver}
                                                            onChange={handleSwitchChange}
                                                            color="primary"
                                                            className="ms-3"
                                                        />
                                                    }
                                                    label=""
                                                />
                                            </h5>
                                        </Col>
                                    </Row>

                                    {/* Last Row: Buttons */}
                                    <Row className="mt-4">
                                        <Col className="d-flex justify-content-start">
                                            <Button variant="primary" className="me-2 volunteersave" onClick={onUpdateCaregiverClick}>
                                                {savechaneg()}
                                            </Button>
                                        </Col>
                                        <Col sm={12} className="mt-2">
                                            {resultMsg && <p className={isSuccess ? "text-success" : "text-danger"}>{resultMsg}</p>}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Caregiver;
